module.exports = __webpack_public_path__ + "static/Minotaur-4ebcf9ad5ec0bff501297fbcd313116a.jpg";